"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _drawLottery = require("@/api/drawLottery");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PrizeRecord',
  directives: {
    hasPermi: {
      inserted: function inserted(el, binding) {
        var value = binding.value;
        var hasPermission = (0, _permission.checkPermi)(value);
        if (!hasPermission) {
          el.parentNode && el.parentNode.removeChild(el);
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      total: 0,
      recordList: [],
      queryParams: {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: ''
      }
    };
  },
  created: function created() {
    console.log('权限检查：', (0, _permission.checkPermi)(['platform:lottery:record:list']));
    if ((0, _permission.checkPermi)(['platform:lottery:record:list'])) {
      this.getList();
    } else {
      this.$message.error('对不起，您没有访问权限');
    }
  },
  methods: {
    getList: function getList() {
      var _this = this;
      if (!(0, _permission.checkPermi)(['platform:lottery:record:list'])) {
        this.$message.error('对不起，您没有访问权限');
        return;
      }
      this.loading = true;
      (0, _drawLottery.drawRecordListApi)(this.queryParams).then(function (res) {
        console.log('API返回数据：', res); // 调试日志
        _this.recordList = res.list || [];
        _this.total = res.total || 0;
        _this.loading = false;
      }).catch(function (error) {
        console.error('API错误：', error);
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams = {
        page: 1,
        limit: 20,
        activityId: '',
        phoneNumber: ''
      };
      this.handleQuery();
    },
    handleSizeChange: function handleSizeChange(val) {
      //选择多少条数据
      this.queryParams.limit = val;
      this.getList('');
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    }
  }
};